import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { sueroterapiaApi } from '../api/sueroterapia.api'
import type { ConfiguracionSueroterapiaUpdateInput, TestConnectionInput } from '../types'

const KEYS = {
  all: ['sueroterapia'] as const,
  config: () => [...KEYS.all, 'config'] as const,
  resumen: (dias: number) => [...KEYS.all, 'resumen', dias] as const,
  registros: (dias: number, limit: number, offset: number) =>
    [...KEYS.all, 'registros', dias, limit, offset] as const,
  registrosPorDia: (dias: number) => [...KEYS.all, 'registros-por-dia', dias] as const,
  registrosPorProvincia: (dias: number) =>
    [...KEYS.all, 'registros-por-provincia', dias] as const,
  busquedas: (dias: number) => [...KEYS.all, 'busquedas', dias] as const,
  videos: (dias: number) => [...KEYS.all, 'videos', dias] as const,
}

export function useConfiguracionSueroterapia() {
  return useQuery({
    queryKey: KEYS.config(),
    queryFn: () => sueroterapiaApi.getConfiguracion(),
  })
}

export function useGuardarConfiguracionSueroterapia() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: ConfiguracionSueroterapiaUpdateInput) =>
      sueroterapiaApi.saveConfiguracion(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: KEYS.config() })
    },
  })
}

export function useTestConnectionSueroterapia() {
  return useMutation({
    mutationFn: (payload?: TestConnectionInput) => sueroterapiaApi.testConnection(payload),
  })
}

export function useResumenSueroterapia(dias: number) {
  return useQuery({
    queryKey: KEYS.resumen(dias),
    queryFn: () => sueroterapiaApi.getResumen(dias),
  })
}

export function useRegistrosSueroterapia(dias: number, limit: number, offset: number) {
  return useQuery({
    queryKey: KEYS.registros(dias, limit, offset),
    queryFn: () => sueroterapiaApi.getRegistros(dias, limit, offset),
  })
}

export function useRegistrosPorDiaSueroterapia(dias: number) {
  return useQuery({
    queryKey: KEYS.registrosPorDia(dias),
    queryFn: () => sueroterapiaApi.getRegistrosPorDia(dias),
  })
}

export function useRegistrosPorProvinciaSueroterapia(dias: number) {
  return useQuery({
    queryKey: KEYS.registrosPorProvincia(dias),
    queryFn: () => sueroterapiaApi.getRegistrosPorProvincia(dias),
  })
}

export function useBusquedasSueroterapia(dias: number) {
  return useQuery({
    queryKey: KEYS.busquedas(dias),
    queryFn: () => sueroterapiaApi.getBusquedas(dias),
  })
}

export function useVideosSueroterapia(dias: number) {
  return useQuery({
    queryKey: KEYS.videos(dias),
    queryFn: () => sueroterapiaApi.getVideos(dias),
  })
}
